/* One consistent notice when an external data source does not answer.
   Text: "A Bybit adatforrás most nem elérhető – újrapróbálás". */
export default function DataSourceDown({ source = 'Bybit', onRetry, style }) {
  return (
    <div className="src-down" role="status" style={style}>
      <span>⚠ A {source} adatforrás most nem elérhető</span>
      {onRetry && (
        <>
          <span aria-hidden="true">–</span>
          <button type="button" className="src-down-retry" onClick={onRetry}>újrapróbálás</button>
        </>
      )}
    </div>
  );
}
